import React, { useContext, useState } from "react";
import { IconCross } from "@ui/icons";
import Container from "@ui/container";
import PopupPage from "@pages/popup-page";
import PopupContext from "@stores/popup-context";
import { useMediumScreen } from "@helpers/use-media-query";

const PopupContainer = (props) => {
    const isMediumScreen = useMediumScreen();

    const style = {
        maxWidth: props.width && isMediumScreen ? `${props.width}px` : null,
    };

    const handleClose = (e) => {
        e.preventDefault();
        const name = e.target?.getAttribute("name");
        if (name && name === "popup-bg") {
            props.handleClose(e);
        }
    };

    return (
        <div
            className="fixed top-0 left-0 w-full h-full bg-black bg-opacity-80 z-[1000] md:px-5"
            name="popup-bg"
            onClick={handleClose}
        >
            <div
                className={`relative left-0 top-0 w-full h-full mx-auto md:mt-16 md:rounded-xl bg-white`}
                style={style}
            >
                <Container className="py-5 border-b md:hidden">
                    <div className="flex  justify-between w-full h-full">
                        <div></div>
                        <div
                            className="cursor-pointer"
                            onClick={props.handleClose}
                        >
                            <IconCross />
                        </div>
                    </div>
                </Container>
                <div
                    className="absolute right-[-25px] top-[-25px] hidden md:block text-white cursor-pointer"
                    onClick={props.handleClose}
                >
                    <IconCross />
                </div>
                {props.children}
            </div>
        </div>
    );
};

const Popup = (props) => {
    const cxt = useContext(PopupContext);

    const handleClose = (e) => {
        e.preventDefault();
        cxt.close();
    };

    return (
        cxt.isOpen && (
            <PopupContainer
                handleClose={handleClose}
                width={cxt.width}
                height={cxt.height}
            >
                {cxt.content ? cxt.content : <PopupPage path={cxt.path} />}
            </PopupContainer>
        )
    );
};

export default Popup;
